import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import gridService from "@/services/grid";

export const useGridPreferencesStore = defineStore("gridPreferences", () => {
  const toast = useToast();
  const loading = ref(false);
  const tableHeaders = ref(null);
  const tableFilters = ref(null);
  const adminPreferenceId = ref(null);

  function resetTableHeaders() {
    tableHeaders.value = {};
  }

  async function onTableHeader(params) {
    loading.value = true;
    try {
      const data = await gridService.getTableHeaders(params);

      if (data.data && data.data.length > 0) {
        tableHeaders.value =
          data.data[0].table_head &&
          typeof data.data[0].table_head !== "object"
            ? JSON.parse(data.data[0].table_head)
            : data.data[0].table_head
            ? data.data[0].table_head
            : null;
        tableFilters.value = data.data[0].url ? data.data[0].url : null;
        adminPreferenceId.value = data.data[0].id;
        localStorage.setItem("adminPreferenceId", data.data[0].id);
      } else {
        tableHeaders.value = null;
        tableFilters.value = null;
        adminPreferenceId.value = null;
      }

      // Auto-create headers for views that support it
      const noAutoCreateUrls = [
        "/device-logs-page",
        "/devices-logs-page",
        "/device-apps",
        "/stores-and-kiosks-grids",
        "/users",
        "/configurations",
        "/password-history",
        "/agents-data-grid",
        "/data-source",
        "/data-mapping",
        "/apps-library",
        "/test-agent",
        "/file-data-mapping",
        "/integrations-grid",
        "/jobs-grid",
        "/agents-instructions",
        "/themes",
        "/themes-assignments-grid",
      ];

      if (!noAutoCreateUrls.includes(params.url)) {
        if (!data.data[0]) {
          await createTableHeaders(params);
        } else if (
          Object.keys(params.headers).length !==
          (typeof data.data[0].table_head !== "object"
            ? Object.keys(JSON.parse(data.data[0].table_head)).length
            : Object.keys(data.data[0].table_head).length)
        ) {
          await createTableHeaders(params);
        }
      }

      return data;
    } catch (err) {
      err?.status !== 401 &&
        toast.error(
          err?.data && err.data.message ? err.data.message : "-",
        );
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function createTableHeaders(params) {
    try {
      const data = await gridService.createTableHeaders(params);
      tableHeaders.value =
        typeof data.data.table_head !== "object"
          ? JSON.parse(data.data.table_head)
          : data.data.table_head;
      tableFilters.value = data.data.url;
      adminPreferenceId.value = data.data.id;
      return data;
    } catch (err) {
      err?.status !== 401 && toast.error(err?.data?.message);
      throw err;
    }
  }

  async function updateTableHeaders(params) {
    loading.value = true;
    try {
      const data = await gridService.updateTableHeaders(params);
      adminPreferenceId.value = data.data.id;
      await onTableHeader(params);
      return data;
    } catch (err) {
      err?.status !== 401 && toast.error(err?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    tableHeaders,
    tableFilters,
    adminPreferenceId,
    resetTableHeaders,
    onTableHeader,
    createTableHeaders,
    updateTableHeaders,
  };
});
